import { getHttpClient, unwrapContainer } from '@/api/client/http-client';
import type {
  NAInterfaceResponseObj,
  OnDemandReqObj,
  OnDemandRespObj,
} from '@/api/models';

export async function sendOnDemandCommand(
  req: OnDemandReqObj,
): Promise<OnDemandRespObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/OnDemandRequest',
    req,
  );
  return unwrapContainer<OnDemandRespObj>(response.data);
}
